import React from "react"
import {
  QueryClient,
  QueryClientProvider as TanstackQueryClientProvider,
} from "@tanstack/react-query"
import { FCWithChildren } from "../interfaces/core"

// A single client instance for the lifetime of the app. Defaults match
// TanStack Query's recommended starting point for an admin app:
// retry on transient failures, but don't refetch in the background
// every focus event (admin tables would flicker).
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 2,
      refetchOnWindowFocus: false,
    },
  },
})

export const QueryClientProvider: FCWithChildren = ({ children }) => (
  <TanstackQueryClientProvider client={queryClient}>
    {children}
  </TanstackQueryClientProvider>
)
